import React from 'react';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Link, useLocation } from 'react-router-dom';

const Breadcrumb = () => {
  const location = useLocation();

  const capitalizeCamelCase = (str) => {
    return str
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join('');
  };


  const pathnames = location.pathname.split('/').filter((x) => x); // Split path and filter out empty strings

  // Generate breadcrumb items dynamically based on pathnames
  const items = pathnames.map((name, index) => {
    const routeTo = `/${pathnames.slice(0, index + 1).join('/store')}`;
    return {
      label: capitalizeCamelCase(name), // Label for the breadcrumb item
      url: routeTo // URL for the breadcrumb item
    };
  });


  // Home configuration for the breadcrumb
  const home = { icon: 'pi pi-home', url: '/store' };

  return (
    <BreadCrumb model={items} home={home} />
  );
};

export default Breadcrumb;
